import React from "react";

import { Paragraph, Strong } from "@moai/core";
import s from "./privacy.module.scss";

interface Props {
    dataText: string;
}

export const Privacy: React.FC<Props> = ({ dataText }) => (
    <div className={s.container}>
        <Paragraph>
            <Strong>Your data are safe here. </Strong>
            <span>
                We process your {dataText} right in the browser, so no data
                shall leave this device.
            </span>
        </Paragraph>
    </div>
);
